import { render, staticRenderFns } from "./LoginTipsBar.vue?vue&type=template&id=56a88f58&scoped=true"
import script from "./LoginTipsBar.vue?vue&type=script&lang=js"
export * from "./LoginTipsBar.vue?vue&type=script&lang=js"
import style0 from "./LoginTipsBar.vue?vue&type=style&index=0&id=56a88f58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a88f58",
  null
  
)

export default component.exports